import React from 'react';
import { hasMinimumLength } from '@/utils/resultsHelper';
import DropdownItem from '@/components/DropdownItem';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import Events from '../hooks/events';

const WorkspaceTools = ({ listItem = false, upward, workspace }) => {
  const showReceipt = Events.useShowWorkspaceRequestReceipt();
  if (!hasMinimumLength(workspace.url) && !hasMinimumLength(workspace.request_form)) {
    return null;
  }

  return (
    <StandardToolsMenu
      allowRead={hasMinimumLength(workspace.url)}
      asHref
      href={workspace.url}
      listItem={listItem}
      upward={upward}
    >
      {hasMinimumLength(workspace.request_form) && (
        <DropdownItem
          icon="align justify"
          textId="actions.view.request"
          onClick={() => showReceipt({ name: workspace.reference || workspace.name, text: workspace.request_form })}
        />
      )}
    </StandardToolsMenu>
  );
};

export default WorkspaceTools;
